import { useMemo } from "react";
import { Box, Chip, IconButton, Tooltip, Typography } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EventIcon from "@mui/icons-material/Event";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { formatFechaCorta } from "../../../common/utils/formatDate";

const bgColorTableHeadCell = "rgba(212, 230, 241, 0.8)";

const DisponibilidadTable = ({ data = [], loading, onToggleFeriado, onEliminar }) => {
  const columns = useMemo(
    () => [
      {
        accessorKey: "fecha",
        header: "Fecha",
        maxSize: 90,
        Cell: ({ cell }) => formatFechaCorta(cell.getValue()),
      },
      { accessorKey: "menu", header: "Menú" },
      { accessorKey: "proveedor", header: "Proveedor" },
      {
        accessorKey: "es_feriado",
        header: "Feriado",
        maxSize: 90,
        muiTableBodyCellProps: { align: "center" },
        muiTableHeadCellProps: { align: "center" },
        Cell: ({ cell, row }) => {
          const esFeriado = Number(cell.getValue()) === 1;
          return (
            <Tooltip title={esFeriado ? "Quitar feriado" : "Marcar como feriado"}>
              <Chip
                icon={
                  esFeriado ? (
                    <EventBusyIcon sx={{ fontSize: 15 }} />
                  ) : (
                    <EventIcon sx={{ fontSize: 15 }} />
                  )
                }
                label={esFeriado ? "Feriado" : "Laborable"}
                size="small"
                onClick={() => onToggleFeriado(row.original.id, esFeriado ? 0 : 1)}
                sx={{
                  cursor: "pointer",
                  fontWeight: 600,
                  bgcolor: esFeriado ? "rgba(211,47,47,0.1)" : "rgba(46,125,50,0.1)",
                  color: esFeriado ? "#B71C1C" : "#1B5E20",
                }}
              />
            </Tooltip>
          );
        },
      },
      {
        id: "acciones",
        header: "",
        maxSize: 60,
        Cell: ({ row }) => (
          <Tooltip title="Eliminar">
            <IconButton size="small" color="error" onClick={() => onEliminar(row.original.id)}>
              <DeleteOutlineIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        ),
      },
    ],
    [onToggleFeriado, onEliminar],
  );

  return (
    <Box boxShadow={1} sx={{ borderRadius: 2, overflow: "hidden" }}>
      <MaterialReactTable
        columns={columns}
        data={data}
        localization={MRT_Localization_ES}
        enableColumnActions={false}
        enableColumnFilters={false}
        enableColumnOrdering={false}
        enableGrouping={false}
        enableHiding={false}
        enableDensityToggle={false}
        enableSorting
        state={{ isLoading: loading, showSkeletons: loading }}
        initialState={{ density: "compact", pagination: { pageIndex: 0, pageSize: 10 } }}
        renderTopToolbarCustomActions={() => (
          <Typography sx={{ fontWeight: 700, color: "#1F618D", pl: 1 }}>
            Ya cargado esta semana
          </Typography>
        )}
        muiTableHeadCellProps={{
          sx: {
            fontSize: 13,
            color: "black",
            fontWeight: "normal",
            backgroundColor: bgColorTableHeadCell,
            borderColor: "#FDFEFE",
          },
        }}
        muiTableBodyRowProps={({ row }) =>
          Number(row.original.es_feriado) === 1
            ? {
                sx: {
                  bgcolor: "rgba(211,47,47,0.05)",
                  borderLeft: "3px solid #D32F2F",
                },
              }
            : {}
        }
      />
    </Box>
  );
};

export default DisponibilidadTable;
